export default __webpack_public_path__ + "static/media/gotv.511f3ca8.svg";